import script from "./VideoUploadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoUploadDialog.vue?vue&type=script&setup=true&lang=js"

import "./VideoUploadDialog.vue?vue&type=style&index=0&id=1eacd820&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eacd820"]])

export default __exports__